import get from 'lodash/get';
import { countryCodesName } from '../../constants/address';
import { capitalizeEachWord } from '../../helpers';
import './styles.scss';
import type { FunctionComponent } from 'react';

type Address = {
  primaryLine?: string;
  secondaryLine?: string;
  city?: string;
  state?: string;
  countryCode?: string;
  zip?: string;
};

type EditAddressSuggestionProps = {
  address?: Address;
  onClose?: () => void;
  onAccept?: () => void;
};

const EditAddressSuggestion: FunctionComponent<EditAddressSuggestionProps> = ({
  onClose = () => {},
  onAccept = () => {},
  address = {},
}) => (
  <div className="edit-address-suggestion">
    <div className="address" data-testid="address-container">
      <p>{capitalizeEachWord(address.primaryLine)}</p>
      <p>{capitalizeEachWord(address.secondaryLine)}</p>
      <p>{`${capitalizeEachWord(address.city)}, ${address.state || ''} ${address.zip || ''}`}</p>
      <p>
        {capitalizeEachWord(get(countryCodesName, address.countryCode || '', '').replace('_', ' '))}
      </p>
    </div>
    <button type="button" className="fffBtnPrimary" onClick={onClose}>
      EDIT ADDRESS
    </button>
    <button type="button" className="btn-link" onClick={onAccept}>
      Use unverified address
    </button>
  </div>
);

export default EditAddressSuggestion;
